module.exports = __webpack_public_path__ + "img/farmer-2.99d37440.svg";